import clsx from 'clsx';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Button } from '@mui/material';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { useEndSessionMutation, useGetUserInfoQuery } from '../../../../services/api';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
({
  button: {
    background: theme.brand,
    color: 'white',
    '&:hover': {
      background: '#600101',
    },
  },
})
);

export default function EndCallButton(props: { className?: string }) {
  const classes = useStyles();
  const { room } = useVideoContext();
  const [endSession] = useEndSessionMutation();
  const { guid } = useParams<{ guid: string }>();
  const { data: user } = useGetUserInfoQuery();
  const handleDisconnect = () => {
    if (guid && user?.role !== 'member') {
      endSession(guid)
        .unwrap()
        .then(() => room!.disconnect());
    }
    else room!.disconnect();
  }
  return (
    <Button
      onClick={handleDisconnect}
      className={clsx(classes.button, props.className)}
      data-cy-disconnect
    >
      Disconnect
    </Button>
  );
}
